var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149.59,
    height: 149.59,
    viewBox: "0 0 149.59 149.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149.59,
    height: 149.59,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.589,74.8A74.8,74.8,0,1,1,74.794,0,74.795,74.795,0,0,1,149.589,74.8",
    transform: "translate(0 0)",
    fill: "#205583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.795,76.025A63.77,63.77,0,1,1,76.024,12.254a63.771,63.771,0,0,1,63.771,63.771",
    transform: "translate(-1.229 -1.229)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.873,140.995a65.12,65.12,0,1,1,65.12-65.12,65.194,65.194,0,0,1-65.12,65.12m0-127.542a62.421,62.421,0,1,0,62.421,62.421A62.492,62.492,0,0,0,75.873,13.453",
    transform: "translate(-1.079 -1.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.795,76.025A63.77,63.77,0,1,1,76.024,12.254a63.771,63.771,0,0,1,63.771,63.771",
    transform: "translate(-1.229 -1.229)",
    fill: "#205583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.873,140.995a65.12,65.12,0,1,1,65.12-65.12,65.194,65.194,0,0,1-65.12,65.12m0-127.542a62.421,62.421,0,1,0,62.421,62.421A62.492,62.492,0,0,0,75.873,13.453",
    transform: "translate(-1.079 -1.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.254,76.025a63.77,63.77,0,1,1,127.541,0Z",
    transform: "translate(-1.229 -1.229)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.994,77.224H10.754v-1.35a65.12,65.12,0,1,1,130.24,0Zm-127.526-2.7H138.28a62.421,62.421,0,0,0-124.813,0",
    transform: "translate(-1.079 -1.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.012,80.409a24.4,24.4,0,0,1,48.8,0Z",
    transform: "translate(-5.619 -5.619)",
    fill: "#205583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.016,81.608h-51.5v-1.35a25.752,25.752,0,0,1,51.5,0Zm-48.766-2.7h46.028a23.054,23.054,0,0,0-46.028,0",
    transform: "translate(-5.469 -5.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 3.224,
    y2: 16.707,
    transform: "translate(65.047 23.048)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.698,
    height: 17.016,
    transform: "translate(63.722 23.304) rotate(-10.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 8.743,
    y2: 14.596,
    transform: "translate(47.844 29.625)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.699,
    height: 17.015,
    transform: "matrix(0.858, -0.514, 0.514, 0.858, 46.686, 30.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 13.208,
    y2: 10.726,
    transform: "translate(33.928 41.688)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.698,
    height: 17.015,
    transform: "translate(33.078 42.735) rotate(-50.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 16.08,
    y2: 5.562,
    transform: "translate(24.978 57.784)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.7,
    height: 17.015,
    transform: "translate(24.536 59.059) rotate(-70.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 6.076,
    x2: 15.893,
    transform: "translate(108.734 56.181)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.014,
    height: 2.699,
    transform: "matrix(0.934, -0.357, 0.357, 0.934, 108.251, 60.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 11.145,
    x2: 12.856,
    transform: "translate(102.306 40.381)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.014,
    height: 2.699,
    transform: "matrix(0.756, -0.655, 0.655, 0.756, 101.421, 50.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 14.87,
    x2: 8.269,
    transform: "translate(92.597 28.772)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.014,
    height: 2.699,
    transform: "translate(91.414 42.984) rotate(-60.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 16.801,
    x2: 2.685,
    transform: "translate(80.776 22.752)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.015,
    height: 2.699,
    transform: "translate(79.444 39.341) rotate(-80.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.577,146.05l10.03-19.233A8.862,8.862,0,0,1,85.488,122l24.869-.037c10.6,0,16.38-8,13.291-16.758-2.729-7.742-11.584-13.385-20.054-13.385l-56.129.005c-1.07,0-1.761-.677-1.546-1.5L47.8,83.134H37.666L34.9,90.984c-1.891,5.362,2.235,10.079,9.376,10.079l61.327,0a6.219,6.219,0,0,1,5.883,4.165c.646,2.418-1.092,4.443-3.9,4.443l-21.544-.005a26.68,26.68,0,0,0-22.273,12.156L51.224,140.913a55.436,55.436,0,0,0,7.749,3.036,67.931,67.931,0,0,0,8.6,2.1",
    transform: "translate(-3.455 -8.34)",
    fill: "#113657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.427,147.249a1.361,1.361,0,0,1-.216-.017,68.754,68.754,0,0,1-8.794-2.147,56.562,56.562,0,0,1-7.956-3.121,1.35,1.35,0,0,1-.516-1.943l12.541-19.089a28.1,28.1,0,0,1,23.4-12.765h.005l21.545.005a2.841,2.841,0,0,0,2.3-.945,2,2,0,0,0,.293-1.8,4.914,4.914,0,0,0-4.579-3.163l-61.327,0c-4.256,0-7.8-1.561-9.726-4.282a8.129,8.129,0,0,1-.923-7.6l2.768-7.851a1.351,1.351,0,0,1,1.273-.9H47.645a1.349,1.349,0,0,1,1.306,1.69l-1.825,6.983a.926.926,0,0,0,.186.016l56.13,0c9.286,0,18.455,6.141,21.327,14.285a13.589,13.589,0,0,1-1.412,12.527c-2.713,3.833-7.506,6.03-13.152,6.03l-24.867.037a7.55,7.55,0,0,0-6.686,4.093L68.623,146.523a1.351,1.351,0,0,1-1.2.726M53.059,140.2a60.106,60.106,0,0,0,6.167,2.313,69.611,69.611,0,0,0,7.462,1.884l9.57-18.352a10.242,10.242,0,0,1,9.076-5.545l24.869-.037c4.761,0,8.751-1.782,10.951-4.889a10.787,10.787,0,0,0,1.07-10.07c-2.468-7-10.718-12.485-18.781-12.485l-56.13,0a3.014,3.014,0,0,1-2.433-1.089,2.414,2.414,0,0,1-.418-2.1l1.436-5.5H38.47l-2.449,6.95a5.433,5.433,0,0,0,.578,5.139c1.412,2,4.156,3.143,7.524,3.143l61.327,0a7.58,7.58,0,0,1,7.188,5.165,4.674,4.674,0,0,1-.76,4.142,5.5,5.5,0,0,1-4.445,2l-21.545-.005h-.005a25.4,25.4,0,0,0-21.142,11.551Z",
    transform: "translate(-3.304 -8.19)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon_3.5cd5971f1b64fb9cf12c7dfe874a5a99.svg";
export { ForwardRef as ReactComponent };